import './CustomData.css';

export const CustomData = ({ children, className = '', ...rest }) => {
  return (
    <div className={`custom-data ${className}`.trim()} {...rest}>
      <div className="custom-data__content">
        {children}
      </div>
    </div>
  );
};

